import { RootState, Status, User } from '../types';

export const getUserStatus = (state: RootState): Status => state.user.status;

export const getUserErrorMsg = (state: RootState): string | null => state.user.errorMsg;

export const getUser = (state: RootState): User | null => state.user.user;

export const getIsPremium = (state: RootState): boolean => state.user.user?.isPremium || false;
